<template>
  <div class="content-container tab-container flex-row">
    <!-- Sidebar -->
    <div class="sidebar left large fixed">
      <div class="fixed-container">
        <overlay-scrollbars :options="{ className: 'sidebar-content-container os-theme-dark', scrollbars: { visibility: 'auto', autoHide: 'leave', autoHideDelay: 400, dragScrolling: true, clickScrolling: false, touchSupport: true, snapHandle: false } }">
          <KundeKontraktObjektTabKjoperUtlevering :kunde="kunde" :objekt="currObj"/>
          <KundeKontraktObjektTabKjoperMottaker :objekt="currObj"/>
          <KundeKontraktObjektTabKjoperLokasjon :objekt="currObj"/>
          <br><br>
        </overlay-scrollbars>
      </div>
    </div>
    <!-- End sidebar -->

    <KundeKontraktObjektTabKjoperBilag :objekt="currObj"/>
  </div>
</template>

<script>
import KundeKontraktObjektTabKjoperUtlevering from './KundeKontraktObjektTabKjoperUtlevering'
import KundeKontraktObjektTabKjoperMottaker from './KundeKontraktObjektTabKjoperMottaker'
import KundeKontraktObjektTabKjoperLokasjon from './KundeKontraktObjektTabKjoperLokasjon'
import KundeKontraktObjektTabKjoperBilag from './KundeKontraktObjektTabKjoperBilag'
import bus from '@/plugins/event-bus'

export default {
  name: 'KundeKontraktObjektTabKjoper',
  components: {
    KundeKontraktObjektTabKjoperUtlevering,
    KundeKontraktObjektTabKjoperMottaker,
    KundeKontraktObjektTabKjoperLokasjon,
    KundeKontraktObjektTabKjoperBilag
  },
  props: {
    kunde: {
      type: Object,
      required: true
    },
    objekt: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      currObj: null
    }
  },
  watch: {
    objekt: function () {
      this.currObj = this._.cloneDeep(this.objekt)
    }
  },
  created () {
    bus.$off('mottaker-updated')

    this.currObj = this._.cloneDeep(this.objekt)
  },
  mounted () {
    bus.$on('mottaker-updated', (data) => this.onMottakerUpdated(data))
  },
  methods: {
    onMottakerUpdated: function (data) {
      this.$set(this.currObj, 'mottaker', data)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/KundeKontraktObjektTabKjoper.vue